import React from 'react';
import PropTypes from 'prop-types';
import './App.css';

function Preview({ markers, onSelectMarker, onClose }) {
  return (
    <div className="preview-container">
      <button className="close-button" onClick={onClose}>×</button>
      {markers.length > 0 ? (
        markers.map((marker) => (
          <div
            key={marker.id}
            className="preview-item"
            onClick={() => {
              onSelectMarker(marker);
            }}
          >
            <div className="preview-title">{marker.title}</div>
            <img
              className="preview-thumbnail"
              src={`https://img.youtube.com/vi/${marker.videoId}/0.jpg`}
              alt={marker.title}
            />
          </div>
        ))
      ) : (
        <div>No markers available</div>
      )}
    </div>
  );
}


Preview.propTypes = {
    markers: PropTypes.array.isRequired,
    onSelectMarker: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};  

export default Preview;
